.dropdown {
  height: 32px;
}
